import React from 'react'
import shortid from "shortid";
import './Style.scss'
import Helper from '../Helper';

const TextBelowImage = ({ blogSectionObj, theme }) => {
    var content = blogSectionObj;

    const titleStyle = {
        fontSize: theme.sectionTitleFontSize ? theme.sectionTitleFontSize : "",
        color: theme.sectionTitleFontColor ? theme.sectionTitleFontColor : "",
        justifyContent: theme.sectionTitleLayout ? theme.sectionTitleLayout : "",
        backgroundColor: theme.sectionTitleBackgroundColor ? theme.sectionTitleBackgroundColor : "",
        fontFamily: theme.sectionTitleFontFamily ? theme.sectionTitleFontFamily : "",
    }
    const bodyStyle = {
        fontSize: theme.sectionBodyFontSize ? theme.sectionBodyFontSize : "",
        color: theme.sectionBodyFontColor ? theme.sectionBodyFontColor : "",
        justifyContent: theme.sectionBodyLayout ? theme.sectionBodyLayout : "",
        backgroundColor: theme.sectionBodyBackgroundColor ? theme.sectionBodyBackgroundColor : "",
        fontFamily: theme.sectionBodyFontFamily ? theme.sectionBodyFontFamily : "",
    }

    return (
        <>
            <div key={shortid.generate()} className='col-md-12 col-sm-12 col-lg-12 col-12'
                data-type="TextBelowImage" >
                    {content?.attributes?.title ?
                        <h3 className='card-text  mt-3' style={titleStyle} id={Helper.labelMerger(content.attributes.title)}>{content.attributes.title}</h3>
                        : ""}
                <div className='card-design'>
                    {content.mainImage ?
                        <img src={`${content.mainImage ? content.mainImage : ""}`} className={`img-fluid ${content.attributes.imageRendering}`} alt={content.attributes.altText} />
                        : ""
                    }
                    {content.body ?
                        <div style={bodyStyle} className={`card-body ${content.attributes && content.attributes.class && content.attributes.class.includes("enquire-button") ? 'enquire-btn-class' : ''}`} dangerouslySetInnerHTML={{ __html: content.body }}></div>
                        : ""}
                </div>
                {theme.horizontalRuler == 'true' ? <hr className='mx-5'></hr> : ""}

            </div>
        </>
    )
}

export default TextBelowImage
